module.exports = __webpack_public_path__ + "img/mz.mz22cb086.svg";